import React from 'react'
import { MdOutlineArrowRightAlt } from 'react-icons/md'
import BlurText from './Animations/BlurText'
import ShinyText from './Animations/ShinyText'
import AnimatedContent from './Animations/AnimatedContent'

export default function Join() {
    return (
        <div>
            <img src="/images/join.png" alt="" className='blink_animation' />
            <div className='md:w-[50%] w-[90%] mx-auto   flex flex-col md:gap-5 gap-3 items-center justify-center md:-mt-[20vw] -mt-[15vw]'>
                <BlurText
                    text="Join Us on the Journet"
                    delay={300}
                    animateBy="words"
                    direction="top"
                    className="md:text-4xl text-[27px] font-medium !text-center"
                />
                <ShinyText text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                    disabled={false} speed={3} className='text-base font-normal text-center  ' />


                <div className='flex items-center md:gap-5 gap-3 mt-5'>

                    <AnimatedContent
                        distance={150}
                        direction="vertical"
                        reverse={false}
                        config={{ tension: 80, friction: 20 }}
                        initialOpacity={0.2}
                        animateOpacity
                        scale={1.1}
                        threshold={0.2}
                    >
                        <a href="">
                            <button class="btn2 md:px-10 px-6 md:py-4 py-3 md:text-base text-sm text-nowrap rounded-full">Join Community </button>
                        </a>
                    </AnimatedContent>
                    <AnimatedContent
                        distance={150}
                        direction="vertical"
                        reverse={false}
                        config={{ tension: 80, friction: 20 }}
                        initialOpacity={0.2}
                        animateOpacity
                        scale={1.1}
                        threshold={0.4}
                    >
                        <a href="">
                            <button class="btn1 md:px-10 px-6 md:py-4 py-3 md:text-base text-sm text-nowrap rounded-full">Learn More</button>
                        </a>
                    </AnimatedContent>
                </div>
            </div>
        </div>
    )
}
